import React, { Component } from "react";
import { Empty, Popconfirm, Space, Table, Tag, Tooltip, message } from "antd";
import { CloseCircleOutlined, PaperClipOutlined, UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";

import { ButtonItem, dineroDisabledMask } from "../../../../Components/Items";

const ESTADOS = {
  0: { texto: "Cancelada", color: "red" },
  1: { texto: "Solicitada", color: "blue" },
  2: { texto: "Recibida", color: "green" },
};

class CotizacionesRecibidas extends Component {
  cancelar = async (cotizacionId) => {
    try {
      const res = await axios.post(
        "cotizacionesRequisicion/cancelarCotizacion",
        { empresaId: this.props.empresaId, cotizacionId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        message.success("Cotización cancelada");
        this.props.onActualizar();
      } else {
        message.error(res.data.message || "No se pudo cancelar la cotización");
      }
    } catch (err) {
      console.error(err);
      message.error("Sucedió un error y no se pudo cancelar");
    }
  };

  render() {
    const { cotizaciones } = this.props;

    if (!cotizaciones || cotizaciones.length === 0) {
      return (
        <Empty description="Todavía no hay cotizaciones para esta requisición" />
      );
    }

    const columnas = [
      { title: "Folio", dataIndex: "numero", width: 80 },
      {
        title: "Proveedor",
        render: (_, valueCotizacion) => valueCotizacion.proveedor?.nombre || "",
      },
      {
        title: "Estado",
        width: 110,
        render: (_, valueCotizacion) => {
          const estado = ESTADOS[valueCotizacion.estado] || {
            texto: "Desconocido",
            color: "default",
          };
          return <Tag color={estado.color}>{estado.texto}</Tag>;
        },
      },
      {
        title: "Solicitada",
        width: 110,
        render: (_, valueCotizacion) =>
          valueCotizacion.fechaSolicitud
            ? moment(valueCotizacion.fechaSolicitud).format("DD/MM/YYYY")
            : "",
      },
      {
        title: "Recibida",
        width: 110,
        render: (_, valueCotizacion) =>
          valueCotizacion.fechaRecepcion
            ? moment(valueCotizacion.fechaRecepcion).format("DD/MM/YYYY")
            : "",
      },
      {
        title: "Vigencia",
        width: 110,
        render: (_, valueCotizacion) =>
          valueCotizacion.vigencia
            ? moment(valueCotizacion.vigencia).format("DD/MM/YYYY")
            : "",
      },
      {
        title: "Partidas",
        width: 90,
        align: "right",
        render: (_, valueCotizacion) => (valueCotizacion.partidas || []).length,
      },
      {
        title: "Total",
        width: 130,
        align: "right",
        render: (_, valueCotizacion) =>
          valueCotizacion.estado === 2 ? dineroDisabledMask(valueCotizacion.total || 0) : "",
      },
      {
        title: "Archivo",
        width: 120,
        render: (_, valueCotizacion) => (
          <Space direction="vertical" size={0}>
            {(valueCotizacion.archivos || []).map((valueArchivo, indice) => (
              <ButtonItem
                key={indice}
                type="link"
                size="small"
                icon={<PaperClipOutlined />}
                onClick={() =>
                  this.props.onVerArchivo(valueCotizacion._id, valueArchivo)
                }
              >
                Ver
              </ButtonItem>
            ))}
          </Space>
        ),
      },
      {
        title: "Acción",
        width: 110,
        render: (_, valueCotizacion) => {
          if (valueCotizacion.estado === 0) return null;
          return (
            <Space>
              <Tooltip
                title={
                  valueCotizacion.estado === 2 ? "Reemplazar cotización" : "Cargar cotización"
                }
              >
                <ButtonItem
                  type="default"
                  size="small"
                  azul
                  icon={<UploadOutlined />}
                  onClick={() => this.props.onCargar(valueCotizacion)}
                />
              </Tooltip>
              <Popconfirm
                title="¿Seguro que quieres cancelar esta cotización?"
                onConfirm={() => this.cancelar(valueCotizacion._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Cancelar">
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<CloseCircleOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            </Space>
          );
        },
      },
    ];

    return (
      <Table
        size="small"
        rowKey="_id"
        columns={columnas}
        dataSource={cotizaciones}
        pagination={{ pageSize: 10 }}
      />
    );
  }
}

export default CotizacionesRecibidas;
